import { useStoreState } from 'easy-peasy'
import React from 'react'
import type { StoreModel } from 'src/store/types'
import { AudioLevelV2 } from './audio-level-v2'

export const AudioLevelClinician = ({
  showLabel
}: {
  showLabel: boolean | null
}) => {
  const { audioLevel } = useStoreState((state: StoreModel) => state.volume)

  return (
    <AudioLevelV2
      label={showLabel ? 'Your microphone' : undefined}
      audioLevel={audioLevel}
    />
  )
}
